module.exports = __webpack_public_path__ + "static/media/Half_W_Art_Body_01.1da2c5b1.csv";